(function () {
  'use strict';

  var SWIPE_THRESHOLD = 50;
  var DRAG_THRESHOLD = 5;

  function isInteractiveDragTarget(target) {
    return !!(target && target.closest('a, button, input, textarea, select, label, [role="button"]'));
  }

  var DRAG_SCROLL_SELECTORS = [
    '[data-spares-viewport]',
    '[data-career-reviews-viewport]',
    '[data-career-team-viewport]',
    '[data-birthday-reviews-viewport]',
    '[data-birthday-bulk-viewport]',
    '.rabitat-celebrities__viewport',
    '.rabitat-press__viewport',
    '.rabitat-video-gallery__viewport',
    '.rabitat-product-page__thumbs',
    '.rabitat-purecore__tabs',
    '[data-rabitat-drag-scroll]',
  ].join(',');

  window.initRabitatSliderTouch = function (element, callbacks) {
    if (!element) return;

    var startX = 0;
    var startY = 0;
    var isTracking = false;
    var didSwipe = false;

    element.classList.add('is-rabitat-swipeable');

    element.addEventListener(
      'pointerdown',
      function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;

        startX = event.clientX;
        startY = event.clientY;
        isTracking = true;
        didSwipe = false;
      },
      { passive: true }
    );

    element.addEventListener(
      'pointermove',
      function (event) {
        if (!isTracking) return;

        var deltaX = event.clientX - startX;
        var deltaY = event.clientY - startY;

        if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 10) {
          isTracking = false;
        }
      },
      { passive: true }
    );

    element.addEventListener(
      'pointerup',
      function (event) {
        if (!isTracking) return;
        isTracking = false;

        var deltaX = event.clientX - startX;
        var deltaY = event.clientY - startY;

        if (Math.abs(deltaX) < SWIPE_THRESHOLD) return;
        if (Math.abs(deltaY) > Math.abs(deltaX)) return;

        didSwipe = true;

        if (deltaX < 0) {
          if (callbacks.onNext) callbacks.onNext();
        } else if (callbacks.onPrev) {
          callbacks.onPrev();
        }

        window.setTimeout(function () {
          didSwipe = false;
        }, 300);
      },
      { passive: true }
    );

    element.addEventListener(
      'pointercancel',
      function () {
        isTracking = false;
      },
      { passive: true }
    );

    element.addEventListener(
      'click',
      function (event) {
        if (didSwipe) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true
    );
  };

  window.initRabitatDragScroll = function (element) {
    if (!element || element.dataset.rabitatDragScrollBound === 'true') return;
    element.dataset.rabitatDragScrollBound = 'true';

    var isDragging = false;
    var startX = 0;
    var scrollLeftStart = 0;
    var didDrag = false;
    var activePointerId = null;

    element.classList.add('is-rabitat-draggable');

    element.addEventListener(
      'pointerdown',
      function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (element.dataset.rabitatDragScroll === 'off') return;
        if (isInteractiveDragTarget(event.target)) return;

        isDragging = true;
        didDrag = false;
        activePointerId = event.pointerId;
        startX = event.clientX;
        scrollLeftStart = element.scrollLeft;

        element.classList.add('is-rabitat-dragging');
        element.style.scrollBehavior = 'auto';

        if (element.setPointerCapture) {
          element.setPointerCapture(event.pointerId);
        }

        event.preventDefault();
      },
      { passive: false }
    );

    element.addEventListener(
      'pointermove',
      function (event) {
        if (!isDragging || event.pointerId !== activePointerId) return;

        var deltaX = event.clientX - startX;

        if (Math.abs(deltaX) > DRAG_THRESHOLD) {
          didDrag = true;
        }

        element.scrollLeft = scrollLeftStart - deltaX;
        event.preventDefault();
      },
      { passive: false }
    );

    function endDrag(event) {
      if (!isDragging) return;
      if (event && event.pointerId !== activePointerId) return;

      isDragging = false;
      activePointerId = null;
      element.classList.remove('is-rabitat-dragging');
      element.style.removeProperty('scroll-behavior');

      if (element.releasePointerCapture && event) {
        try {
          element.releasePointerCapture(event.pointerId);
        } catch (error) {
          /* pointer already released */
        }
      }

      if (didDrag) {
        window.setTimeout(function () {
          didDrag = false;
        }, 0);
      }
    }

    element.addEventListener('pointerup', endDrag);
    element.addEventListener('pointercancel', endDrag);
    element.addEventListener('lostpointercapture', function () {
      if (isDragging) {
        isDragging = false;
        activePointerId = null;
        element.classList.remove('is-rabitat-dragging');
        element.style.removeProperty('scroll-behavior');
      }
    });

    element.addEventListener(
      'click',
      function (event) {
        if (didDrag) {
          event.preventDefault();
          event.stopImmediatePropagation();
          didDrag = false;
        }
      },
      true
    );

    element.addEventListener(
      'dragstart',
      function (event) {
        event.preventDefault();
      },
      { passive: false }
    );
  };

  function initAllDragScroll() {
    document.querySelectorAll(DRAG_SCROLL_SELECTORS).forEach(function (element) {
      if (element.dataset.rabitatDragScroll === 'off') return;
      if (element.matches('[data-collection-viewport]')) return;
      window.initRabitatDragScroll(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllDragScroll);
  } else {
    initAllDragScroll();
  }

  document.addEventListener('shopify:section:load', initAllDragScroll);
})();
